const textContents = {
    "startPage": {
        "Finland": { "fin": "suomeksi", "rus": "Финский" },
        "Russia": {  "fin": "venäjäksi", "rus": "Русский" },
        "Start": { "fin": "Aloita peli", "rus": "Начать игру" },
        "GameName": {  "fin": "Mitä eläimiä Venäjällä elää", "rus": "Кто живёт в России" },
        "Welcome": {  "fin": "Valitse pelin kieli", "rus": "Выбери язык игры" }
    },
    "topMenu": {
        "NavbarFi": {  "fin": "Su", "rus": "Фи" },
        "NavbarRu": { "fin": "Ve", "rus": "Ру" },
        "NavbarClose": { "fin": "X", "rus": "X" },
        "NavbarInfo": {  "fin": "?", "rus": "?" },
        "GameTitle": {  "fin": "Mitä eläimiä Venäjällä elää", "rus": "Кто живёт в России" }
    },
    "textGame": {
        "HowToPlay": {  "fin": "Kuinka pelata", "rus": "Как играть" },
        "HowToPlayText": {
            "fin": ["Ensimmäisessä ruudussa ovat suomen aakkosten kirjaimet.", "Napsauttamalla mitä tahansa kirjainta kursorilla,", "avautuu kyseisen kirjaimen ruutu. ", "Nuolella ”Eteenpäin” siirryt ruudulle,", "joissa on temaattisia kuvia.", "Nuolella ”Takaisin” voit tarkastella", "aikaisemmin katsottuja kuvia.", "Napsauttamalla kursorilla ”A B C” -painiketta,", "pelaaja palaa ensimmäiseen ruutuun.", "", "Aikuisen tehtävä: auttaa lasta ", "ja lausua oikein ääneen kuvissa esitetyt sanat. ", "Varsinkin ne sanat, jotka eivät vielä ole tuttuja lapselle.", "Pelin aikana lapset selvittävät mitä eläimiä", "elää Venäjällä ja laajentavat sanastoaan.", "Onnea peliin! "], 
            "rus": ["На первом экране расположены буквы русского алфавита. ", "Нажав на любую букву, откроется экран с данной буквой. ", "По стрелке «Вперёд» переход на экраны  ", "с тематическими картинками. По стрелке «Назад» ", "можно просмотреть пройденные картинки. ", "Нажав на кнопку «А Б В» курсором, ", "игрок возвратится на первый экран. ", " ", "Задача взрослого: помочь ребёнку ", "и правильно произносить вслух слова, ", " изображённые на картинках.", "Особенно те слова, которые ещё не знакомы ребёнку. ", "В ходе игры дети узнают, кто живёт в России, ", "и расширяют свой словарный запас. ", " ", "Удачи в игре!"]
        },
        "Continue": { "fin": "Jatka", "rus": "Продолжить" },
        "AlphabetName": { "fin": "SUOMEN AAKKOSET", "rus": "РУССКИЙ АЛФАВИТ" },
        "PlayAgain": {  "fin": "Aloita alusta", "rus": "Начать с начала" },
        "GameInfo": { "fin": "Valitse kirjain", "rus": "Выбери букву"}
    },
    "colorAlphabetRus": { "А": "1", "Б": "2", "В": "2", "Г": "2", "Д": "2", "Е": "1", "Ё": "1", "Ж": "2", "З": "2", "И": "1", "Й": "1", "К": "2", "Л": "2", "М": "2", "Н": "2", "О": "1", "П": "2", "Р": "2", "С": "2", "Т": "2", "У": "1", "Ф": "2", "Х": "2", "Ц": "2", "Ч": "2", "Ш": "2", "Щ": "2", "Ъ": "3", "Ы": "1", "Ь": "3", "Э": "1", "Ю": "1", "Я": "1" },
    "colorAlphabetFin": { "A": "1", "B": "2", "C": "2", "D": "2", "E": "1", "F": "2", "G": "2", "H": "2", "I": "1", "J": "1", "K": "2", "L": "2", "M": "2", "N": "2", "O": "1", "P": "2", "Q": "2", "R": "2", "S": "2", "T": "2", "U": "1", "V": "2", "W": "2", "X": "2", "Y": "1", "Z": "2", "Ä": "1", "Ö": "1" },
"content": {
    "Aist": {
        "fin": { "H": "Haikara"  }, 
        "rus": { "А": "Аист" }
    },
    "Akula": {
        "fin": { "H": "Hai"},
        "rus": { "А": "Акула" }
    },
    "AmurskiTigr": {
        "fin": { "A": "Amurintiikeri" },
        "rus": { "А": "Амурский тигр"}
    },
    "Bober": {
        "fin": { "M": "Majava" },
        "rus": { "Б": "Бобёр", "Ё": "БобЁр" }
    },
    "Babochka": {
        "fin": {  "P": "Perhonen" },
        "rus": {  "Б": "Бабочка" }
    },
    "Belka": {
        "fin": { "O": "Orava" },
        "rus": { "Б": "Белка" }
    },
    "Burunduk": {
        "fin": { "M": "Maaorava" },
        "rus": {  "Б": "Бурундук"}
    },
    "BelyiMedved": {
        "fin": { "J": "Jääkarhu" },
        "rus": { "Б": "Белый медведь" }
    },
    "Byk": {
        "fin": {"H": "Härkä" },
        "rus": {"Б": "Бык"   }
    },
    "Volk": {
        "fin": { "S": "Susi" },
        "rus": { "В": "Волк" }
    },
    "Vorobey": {
        "fin": { "V": "Varpunen" },
        "rus": { "В": "Воробей"  }
    },
    "Vorona": {
        "fin": { "V": "Varis"  },
        "rus": {"В": "Ворона" }
    },
    "Vidra": {
        "fin": {"S": "Saukko" },
        "rus": {"В": "Выдра"  }
    },
    "Galka": {
        "fin": { "N": "Naakka" },
        "rus": { "Г": "Галка"  }
    },
    "Grach": {
        "fin": { "P": "Peltovaris"  },
        "rus": { "Г": "Грач"  }
    },
    "Golub": { 
        "fin": {  "K": "Kyyhkynen"  },
        "rus": {
            "Г": "Голубь", "Ь": "голубЬ" }
    },
    "Gornostai": {
        "fin": {  "K": "Kärppä"  },
        "rus": {  "Г": "Горностай", "Й": "горностаЙ"  }
    },
    "Gusenica": {
        "fin": {  "T": "Toukka" },
        "rus": {  "Г": "Гусеница" }
    },
    "Gus": {
        "fin": {  "H": "Hanhi"  },
        "rus": {  "Г": "Гусь"  }
    },
    "Delfin": {
        "fin": {  "D": "Delfiini"  },
        "rus": {  "Д": "Дельфин"   }
    },
    "Djatel": {
        "fin": {  "T": "Tikka"  },
        "rus": {  "Д": "Дятел"  }
    },
    "Ezik": {
        "fin": { "S": "Siili"  },
        "rus": { "Ё": "Ёжик"   }
    },
    "Ersh": {
        "fin": { "K": "Kiiski" },
        "rus": { "Ё": "Ёрш"  }
    },
    "Enot": {
        "fin": { "S": "Supi"  },
        "rus": { "Е": "Енот"  }
    },
    "Zuravl": {
        "fin": { "K": "Kurki"  },
        "rus": { "Ж": "Журавль"}
    },
    "Zuk": {
        "fin": { "K": "Kuoriainen" },
        "rus": { "Ж": "Жук" }
    },
    "Zaba": {
        "fin": { "K": "Konna" },
        "rus": { "Ж": "Жаба " }
    },
    "Zajac": {
        "fin": { "J": "Jänis" },
        "rus": { "З": "Заяц"  }
    },
    "Zmeja": {
        "fin": {"K": "Käärme" },
        "rus": {"З": "Змея"   }
    },
    "Ivolga": {
        "fin": {"K": "Kuhankeittäjä" },
        "rus": {"И": "Иволга" }
    },
    "Indjuk": {
        "fin": {"K": "Kalkkuna" },
        "rus": { "И": "Индюк" }
    },
    "Solovei": {
        "fin": {
            "": ["S", "Satakieli"]
        },
        "rus": {
            "Й": "соловеЙ", "С": "Соловей"  }
    },
    "Kaban": {
        "fin": { "M": "Metsäsika" },
        "rus": { "K": "Kабан" }
    },
    "Karas": {
        "fin": { "R": "Ruutana" },
        "rus": { "K": "Kарась" }
    },
    "Kasatka": {
        "fin": { "M": "Miekkavalas" },
        "rus": { "К": "Косатка" }
    },
    "Kit": {
        "fin": { "V": "Valas" },
        "rus": { "K": "Kит" }
    },
    "Klest": {
        "fin": { "K": "Käpylintu" },
        "rus": { "К": "Клёст" }
    },
    "Koza": {
        "fin": { "V": "Vuohi" },
        "rus": { "К": "Коза" }
    },
    "Komar": {
        "fin": { "H": "Hyttynen" },
        "rus": { "К": "Комар" }
    },
    "Korova": {
        "fin": { "L": "Lehmä" },
        "rus": { "К": "Корова" }
    },
    "Korjushka": {
        "fin": { "K": "Kuore" },
        "rus": { "К": "Корюшка" }
    },
    "Kot": {
        "fin": { "K": "Kissa" },
        "rus": { "К": "Кошка" }
    },
    "Kuznechik": {
        "fin": { "H": "Heinäsirkka" },
        "rus": { "К": "Кузнечик" }
    },
    "Lebed": {
        "fin": { "J": "Joutsen" },
        "rus": { "Л": "Лебедь" }
    },
    "Lica": {
        "fin": { "K": "Kettu" },
        "rus": { "Л": "Лиса" }
    },
    "Locj": {
        "fin": { "H": "Hirvi" },
        "rus": { "Л": "Лось" }
    },
    "Medved": {
        "fin": { "K": "Karhu" },
        "rus": { "М": "Медведь" }
    },
    "Mysh": {
        "fin": { "H": "Hiiri" },
        "rus": {
            "М": "Мышь", "Ы": "мЫшь" }
    },
    "Nerpa": {
        "fin": { "N": "Norppa" },
        "rus": { "Н": "Нерпа" }
    },
    "Orel": {
        "fin": { "K": "Kotka" },
        "rus": { "О": "Орёл" }
    },
    "Osa": {
        "fin": { "A": "Ampiainen" },
        "rus": { "О": "Оса" }
    },
    "Risy": {
        "fin": { "I": "Ilves" },
        "rus": { "Р": "Рысь" }
    },
    "Sobaka": {
        "fin": { "K": "Koira" },
        "rus": { "С": "Собака" }
    },
    "Svinka": {
        "fin": { "S": "Sika" },
        "rus": { "С": "Свинья" }
    },
    "Pingvin": {
        "fin": { "P": "Pingviini" },
        "rus": { "П": "Пингвин" }
    },
    "Ulitka": {
        "fin": { "E": "Etana" },
        "rus": { "У": "Улитка" }
    },
    "Filin": {
        "fin": { "H": "Huuhkaja" },
        "rus": { "Ф": "Филин" }
    },
    "HohlatajaSinica": {
        "fin": { "H": "Harjas tiainen" },
        "rus": { "Х": "Хохлатая синица" }
    },
    "Jak": {
        "fin": { "J": "Jakki" },
        "rus": { "Я": "Як" }
    },
    "Tushkanchik": {
        "fin": { "H": "Hyppyrotta" },
        "rus": { "Т": "Тушканчик" }
    },
    "Caplja": {
        "fin": { "H": "Haikara" },
        "rus": { "Ц": "Цапля" }
    },
    "Cherepaha": {
        "fin": { "K": "Kilpikonna" },
        "rus": { "Ч": "Черепаха" }
    },
    "Shuka": {
        "fin": { "H": "Hauki" },
        "rus": { "Щ": "Щука" }
    },
    "Jurok": {
        "fin": { "J": "Järripeippo" },
        "rus": { "Ю": "Юрок" }
    },
    "Shmel": {
        "fin": { "K": "Kimalainen" },
        "rus": { "Ш": "Шмель" }
    },
    "Evlenga": {
        "fin": { "E": "Euglena" },
        "rus": { "Э": "Эвглена" }
    }
}
}
export default textContents;